import type {
  Asset,
  AssetState,
  AssetToWorkflowStateMapping,
  AssetWorkflowStepOptions,
  WorkflowContext,
  WorkflowStateToAssetMapping,
  WorkflowStepOptions,
} from './types';
import { WorkflowStep } from './WorkflowStep';
export interface WorkflowOptions {
  workflowName: string;
  workflowSteps: WorkflowStepOptions[];
}

export class EditAssetWorkflowStep extends WorkflowStep {
  public readonly workflowStateToAssetMapping?: WorkflowStateToAssetMapping;
  public readonly assetToWorkflowMapping?: AssetToWorkflowStateMapping;
  private readonly asset: Asset;
  private readonly markComplete: boolean;
  constructor(workflowKey: string, options: AssetWorkflowStepOptions, asset: Asset, assetState: AssetState) {
    super(workflowKey, options, assetState);
    this.workflowStateToAssetMapping = options.workflowStateToAssetMapping;
    this.assetToWorkflowMapping = options.assetToWorkflowStateMapping;
    this.asset = asset;
    this.markComplete = options.markComplete ? true : false;
  }
  public isComplete(context: WorkflowContext) {
    const state = context.workflowState[context.workflowKey] || {};
    return state[this.workflowStepKey] !== undefined || this.markComplete || this.optional;
  }
  public calculateComponentProps(context: WorkflowContext) {
    return {
      ...this.workflowComponent,
      ...(this.calculatedComponentProps
        ? Object.entries(this.calculatedComponentProps).reduce<Record<string, unknown>>((prev, curr) => {
            const transform = curr[1]?.transformFn ? curr[1]?.transformFn : (p: any) => p;
            prev[curr[0]] =
              curr[1].type === 'asset'
                ? transform((this.asset as any)[curr[1].property])
                : transform(context.workflowState[context.workflowKey][curr[1].property]);
            return prev;
          }, {})
        : {}),
    };
  }
}
